module.exports = __webpack_public_path__ + "static/img/newbg.de5f4982.png";